
import { Validation } from "./Validation";
import { CategoryTypeType } from "../shared/CategoryTypeType";

/**
 * Kategorie-Typen zur Sortierung und fuer besondere Funktionen (spezielle Preise).
 */
export default interface CategoryTypeJson {
   ID: number | null;

   /**
    * Titel der Kategorie
    */
   title: string;

   /**
    * Art der Kategorie (Zuordnung zu bestimmten Modulen)
    */
   type: CategoryTypeType;

   /**
    * Gruppierung zur Sortierung zusammengehörender Kategorien
    */
   grouping: string;

   /**
    * Farbe der Kategorie als hex String (#0011FF).
    */
   colorHexString: string;
}

export function defaultCategoryTypeJson(): CategoryTypeJson {
   return {
      ID: null,
      title: "",
      type: CategoryTypeType.client,
      grouping: "",
      colorHexString: "",
   };
}

export function validateCategoryTypeJsonAddNew(item: CategoryTypeJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateNonEmptyString("title", 255)
      .validateString("grouping", 100)
      .validateString("colorHexString", 10)
      .finish();
}

export function validateCategoryTypeJson(item: CategoryTypeJson) {
   return new Validation(item)
      .validateInteger("ID", 0)
      .validateNonEmptyString("title", 255)
      .validateString("grouping", 100)
      .validateString("colorHexString", 10)
      .finish();
}